import {Box, Typography} from '@mui/material';
import type {FC} from 'react';
import {
  Datagrid,
  DateField,
  DeleteButton,
  Edit,
  EditButton,
  List,
  ReferenceInput,
  ReferenceManyField,
  required,
  SelectInput,
  SimpleForm,
  TextField,
  TextInput,
} from 'react-admin';
import {InventoryPlotDatagrid} from '@/admin/resources/inventoryPlots/InventoryPlots';
import {UavPointCloudDatagrid} from '@/admin/resources/uavPointClouds/UavPointClouds';

export const ForestMassList: FC = () => (
  <List>
    <Datagrid rowClick="edit">
      <TextField source="code" />
      <TextField source="appraiserUuid" label="Appraiser" />
      <DateField source="plannedCuttingDate" label="Planned Cut" />
      <DateField source="createdAt" label="Created" />
      <DateField source="updatedAt" label="Updated" />
      <EditButton />
      <DeleteButton />
    </Datagrid>
  </List>
);

export const ForestMassEdit: FC = () => (
  <Edit>
    <SimpleForm>
      <TextInput source="code" validate={[required()]} />
      <ReferenceInput source="appraiserUuid" reference="appraisers">
        <SelectInput optionText="name" />
      </ReferenceInput>
      <TextInput source="plannedCuttingDate" type="date" label="Planned Cutting Date" />
    </SimpleForm>
    <Box mt={2}>
      <Typography variant="h4">UAV Point Clouds</Typography>
      <ReferenceManyField reference="uav-point-clouds" target="forestMassUuid">
        <UavPointCloudDatagrid />
      </ReferenceManyField>
    </Box>
    <Box mt={2}>
      <Typography variant="h4">Inventory Plots</Typography>
      <ReferenceManyField reference="inventory-plots" target="forestMassUuid">
        <InventoryPlotDatagrid />
      </ReferenceManyField>
    </Box>
  </Edit>
);
